export const formatDate = (date: string | undefined, locales: Intl.LocalesArgument = 'en-US'): string => {
  if (!date) return '';
  if (date == 'N/A') return date;

  const parsedDate = new Date(date);
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  };
  return parsedDate.toLocaleDateString(locales, options);
};

export const formatDateShort = (date: string | undefined, locales: Intl.LocalesArgument = 'en-US'): string => {
  if (!date) return '-';
  if (date == 'N/A') return date;
  if (date === '0001-01-01T00:00:00') return '-';

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return '-';

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  };
  return parsedDate.toLocaleDateString(locales, options);
};

export const formatDateMonth = (date: string | undefined, locales: Intl.LocalesArgument = 'en-US'): string => {
  if (!date) return '';
  if (date == 'N/A') return date;
  if (date === '0001-01-01T00:00:00') return '-';

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return '-';

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
  };
  return parsedDate.toLocaleDateString(locales, options);
};

export const formatDateTime = (date: string | undefined, locales: Intl.LocalesArgument = 'en-US'): string => {
  if (!date) return '';
  if (date == 'N/A') return date;

  const parsedDate = new Date(date);
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  };
  return parsedDate.toLocaleDateString(locales, options);
};

export const formatDateTimeSince = (date: string | undefined, locales: Intl.LocalesArgument = 'en-US'): string => {
  if (!date) return '';
  if (date == 'N/A') return date;

  const parsedDate = new Date(date);
  if (isNaN(parsedDate.getTime())) return '';
  const now = new Date();
  const diffMs = now.getTime() - parsedDate.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  // If more than 7 days ago, use formatDateTime
  if (diffDays > 7) {
    return formatDateTime(date, locales);
  }

  const diffHours = Math.floor((diffMs / (1000 * 60 * 60)) % 24);
  const diffMinutes = Math.floor((diffMs / (1000 * 60)) % 60);

  let sinceString = '';
  if (diffDays > 0) {
    sinceString += `${diffDays} d `;
  }
  if (diffHours > 0) {
    sinceString += `${diffHours} h `;
  }
  if (diffMinutes > 0 && diffDays === 0) {
    sinceString += `${diffMinutes} min`;
  }
  if (sinceString === '') {
    sinceString = 'just now';
  } else {
    sinceString += ' ago';
  }

  return sinceString.trim();
};

export const getDateRange = (year: string, month: string) => {
  if (year && month) {
    // Both year and month are set - use specific month
    // Get the last day of the month by creating a Date with day 0 of next month
    const lastDay = new Date(parseInt(year), parseInt(month), 0).getDate();
    return {
      startDate: `${year}-${month}-01`,
      endDate: `${year}-${month}-${lastDay.toString().padStart(2, '0')}`,
    };
  } else if (year) {
    // Only year is set - use full year
    return {
      startDate: `${year}-01-01`,
      endDate: `${year}-12-31`,
    };
  } else {
    // Neither is set - use wide range
    return {
      startDate: '2000-01-01',
      endDate: '2099-12-31',
    };
  }
};
